import Vue from 'vue'
import Router from 'vue-router'
import DemoStream from './views/DemoStream.vue'
import DemoMobileStream from "./views/DemoMobileStream";
import DemoCallUser from "./views/DemoCallUser";
import TechLayout from "./layouts/TechLayout";
import Call from "./views/Call";
import LogIn from "./views/LogIn";
import store from './store/store'
import Contacts from "./views/Contacts";
import SessionLogs from "./views/SessionLogs";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import ExternalLogin from "./views/ExternalLogin";
import TimeSlice from "./views/TimeSlice";
import TimeslicePlayerPage from "./views/TimeslicePlayerPage";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/tech',
      name: 'Tech',
      component: TechLayout,
      children: [
        {
          path: 'contacts',
          name: 'Contacts',
          component: Contacts,
          meta: {
            title: 'Vision | Contacts'
          }
        },
        {
          path: 'contacts/:callSid',
          name: 'ContactActiveCall',
          component: Contacts,
          props: true,
          meta: {
            title: 'Vision | Call'
          }
        },
        {
          path: 'call',
          name: 'Call',
          component: Call
        },
        {
          path: 'call/:callSid',
          name: 'ActiveCall',
          component: Call,
          props: true
        },
        {
          path: 'video/:sessionId',
          name: 'ActiveVideoSession',
          component: Call,
          props: true
        },
        {
          path: 'demo-stream',
          name: 'DemoStream',
          component: DemoStream
        },
        {
          path: 'mobile-demo-stream',
          name: 'DemoMobileStream',
          component: DemoMobileStream
        },
        {
          path: 'call-user-demo',
          name: 'DemoCallUser',
          component: DemoCallUser
        },
        {
          path: 'session-logs',
          name: 'SessionLogs',
          component: SessionLogs,
          meta: {
            title: 'Vision | Logs'
          }
        },
        {
          path: '*',
          redirect: 'call'
        }
      ]
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
    },
    {
      path: '/reset-password/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      props: true
    },
    {
      path: '/external-login/:token',
      name: 'ExternalLogin',
      component: ExternalLogin,
      props: true
    },
    {
      path: '/log-in',
      component: LogIn,
      name: "Login",
      beforeEnter(to, from, next) {
        if (store.state.auth.self) {
          next(false)
        } else {
          next()
        }
      },
      meta: {
        title: 'Vision | Log In'
      }
    },
    {
      path: '/timeslice',
      component: TimeSlice,
      name: 'TimeSlice'
    },
    {
      path: '/timeslice-player',
      component: TimeslicePlayerPage,
      name: 'TimeslicePlayerPage'
    },
    {
      path: '/timeslice-player/:id',
      component: TimeslicePlayerPage,
      name: 'TimeslicePlayerPage',
      props: true
    },
    {
      path: '*',
      redirect: '/tech/contacts'
    },
  ]
});

router.beforeEach((to, from, next) => {
  if (!store.state.auth.self &&
    to.path !== '/log-in'
    && to.path !== '/forgot-password'
    && !to.path.startsWith('/external-login')
    && !to.path.startsWith('/timeslice')
    && !to.path.startsWith('/reset-password')) {
    next('/log-in')
  } else if(store.state.global.isCallInProgress) {
    next(false)
  } else {
    next()
  }
});

export default router;
